module.exports = __webpack_public_path__ + "static/media/PPMDP.81ed499e.pdf";